var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfLogo(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.086 0H4.914A4.914 4.914 0 000 4.914v10.172C0 17.8 2.2 20 4.914 20h10.172C17.8 20 20 17.8 20 15.086V4.914C20 2.2 17.8 0 15.086 0z",
    fill: "#00A0EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.308 4.581H6.646l-.25 1.776h4.908a2.484 2.484 0 011.807.707 2.502 2.502 0 01.558 2.766 2.503 2.503 0 01-1.39 1.357c-.31.121-.642.179-.975.17H7.356l.256-1.618h3.48a.879.879 0 00.88-.883.885.885 0 00-.88-.883h-4.96l-1.323 8.44h1.76l.513-3.304h4.226a4.236 4.236 0 003.064-1.216 4.265 4.265 0 001.277-3.048 4.278 4.278 0 00-1.277-3.048 4.248 4.248 0 00-3.064-1.216z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfLogo);
export default ForwardRef;